<script>
    import './login.scss'

    export default {}
</script>
